export default __webpack_public_path__ + "4504d06cbb5b79e41a417f6bcf503481.png";